//  Helper function to build query strings
const buildQueryString = (params) => {
  if (!params || Object.keys(params).length === 0) return "";

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      if (Array.isArray(value)) {
        value.forEach((v) => searchParams.append(key, v.toString()));
      } else {
        searchParams.append(key, value.toString());
      }
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

export const ENDPOINTS = {
  // Job-related endpoints
  JOBS: {
    LIST_APPLICATIONS: (
      queries = {} // Get all applicants for all user jobs
    ) => `job-application/${buildQueryString(queries)}`,
    APPLICANT_BY_ID: (
      app_id,
      user_id // Get application Details of user
    ) => `job-application-by-id/${app_id}/${buildQueryString({ user_id })}`,
    JOB_POSTS: (queries = {}) => `/jobs/${buildQueryString(queries)}`, // Get Job posts by a user with filters
    JOB_POST_DETAIL: (job_Id, user_id) =>
      `jobs-by-id/${job_Id}/${buildQueryString(user_id)}`, // Get Details of a Job
    JOB_APPLICANTS: (job_Id, queries = {}) =>
      `/job-applications-by-job-id/${job_Id}/${buildQueryString(queries)}`, // Get Job applicants for a Job

    DELETE_JOB_POST: (queries = {}) => `/jobs/${buildQueryString(queries)}`, // Delete job detail by job ID
    BULK_DOWNLOAD_CV: (queries = {}) =>
      `/download-cv/${buildQueryString(queries)}`, // Bulk download of Vs queries= comma separated list
  },

  // Authentication endpoints
  AUTH: {
    LOGIN: "/job-admin/login/",
    LOGOUT: (userId) => `/auth/logout/${userId}`,
    REGISTER: "/job-admin/create-account/",
    REFRESH: "/job-admin/refresh-token",
    FORGOT_PASSWORD: "/job-admin/forgot-password/",
    RESET_PASSWORD: (userId) => `/job-admin/change-password/${userId}/`,
  },

  // Profile endpoints
  USER: {
    USER_PROFILE: (user_id) => `job-admin/profile/${user_id}/`,
    UPDATE_PROFILE: (userId) => `/job-admin/profile/${userId}/`,
    DELETE_PROFILE: (userId) => `/job-admin/profile/${userId}/`,
  },
};
